import {request,newVue,requestMsg} from "./request";
export {newVue}

/**
 * 分页
 * @param pageNum
 * @param pageSize
 * @param name
 * @param phone
 * @returns {AxiosPromise}
 */
export function getCollectionBySearch(pageNum,pageSize,name,phone) {
    return request({
        url: '/collection/queryCollectorDetailByParam',
        params: {
            pageNum: pageNum,
            pageSize: pageSize,
            name:name,
            phone:phone
        }
    })
}

/**
 * 采集单分页
 * @param pageNum
 * @param pageSize
 * @param name
 * @param phone
 * @returns {AxiosPromise}
 */
export function queryCentralizedPurchaseOrderPagination(pageNum,pageSize,name,id,status) {
    return request({
        url: '/collection/queryCentralizedPurchaseOrderPagination',
        params: {
            pageNum: pageNum,
            pageSize: pageSize,
            id:id,
            name:name,
            status:status
        }
    })
}

/**
 * 删除
 * @param id
 * @returns {AxiosPromise}
 */
export function delByCollectionId(id) {
    return requestMsg({
        url: '/collection/deleteCollector',
        params: {
            id:id
        }
    })
}

export function queryCollectorById(id) {
    return request({
        url: '/collection/queryCollectorById',
        params: {
            Id:id
        }
    })
}
export function queryCentralizedPurchaseOrderDetailById(id) {
    return request({
        url: '/collection/queryCentralizedPurchaseOrderDetailById',
        params: {
            Id:id
        }
    })
}


export function queryCentralizedPurchaseOrderById(id) {
    return request({
        url: '/collection/queryCentralizedPurchaseOrderById',
        params: {
            Id:id
        }
    })
}

export function addupdateCoupons(collector) {
    return requestMsg({
        url: '/collection/addOrUpdateCollector',
        data: JSON.stringify(collector),
        method: "POST",
        headers : {"Content-Type" : "application/json;charset=utf-8"},
    })
}

export function addOrUpdateCentralizedPurchaseOrder(order) {
    return requestMsg({
        url: '/collection/addOrUpdateCentralizedPurchaseOrder',
        data: JSON.stringify(order),
        method: "POST",
        headers : {"Content-Type" : "application/json;charset=utf-8"},
    })
}

export function sendSmsMsg(mobile,code,templeteContent) {
    return request({
        url: '/collection/sendSmsMsg',
        params: {
            mobile:mobile,
            code:code,
            templeteContent:templeteContent
        }
    })
}

/**
 * 根据手机号查看采集员
 * @param collector
 * @returns {AxiosPromise}
 */
export function getUserByPhone(phone) {
    return requestMsg({
        url: '/user/getUserByPhone',
        params: {
            phone:phone
        }
    })


}/**
 * 根据id查询采集商详情
 * @param collector
 * @returns {AxiosPromise}
 */
export function queryCollectorDetailById(id) {
    return requestMsg({
        url: '/collection/queryCollectorDetailById',
        params: {
            id:id
        }
    })
}

/**
 * 根据名字查询采集商
 * @param id
 * @returns {AxiosPromise}
 */
export function queryCollectorByName(name) {
    return requestMsg({
        url: '/collection/queryCollectorByName',
        params: {
            Name:name
        }
    })
}

/**
 * 查询采集商品
 * @param id
 * @returns {AxiosPromise}
 */
export function getSkuInfoListByClassifyIdAndName(classify,name) {
    return requestMsg({
        url: '/skuInfo/getSkuInfoListByClassifyIdAndName',
        params: {
            ClassifyId:classify,
            Name:name
        }
    })
}

/**
 * 更新采集单状态以及对应状态
 * @param order
 * @returns {AxiosPromise}
 */
export function updateCentralizedPurchaseOrderStatus(order) {
    return requestMsg({
        url: '/collection/updateCentralizedPurchaseOrderStatus',
        data: JSON.stringify(order),
        method: "POST",
        headers : {"Content-Type" : "application/json;charset=utf-8"},
    })
}